import { Component, ViewChild } from "@angular/core";
import { MatMenuTrigger } from "@angular/material/menu";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { EntityActionTypes, ofEntityType } from "@briebug/ngrx-auto-entity";
import { Actions } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { AuthState, getAuthState } from "app/main/auth/store/auth.reducer";
import { DocumentationFacade } from "app/main/documentation/documentation.facade";
import { Documentation } from "app/main/documentation/documentation.model";
import { SpinnerService } from "app/main/pages/spinner/spinner.service";
import { SousDocumentationFacade } from "app/main/sousdocumentation/sousdocumentation.facade";
import { SousDocumentation } from "app/main/sousdocumentation/sousdocumentation.model";
import { EntityService } from "app/shared/service/entity.service";
import { MediaService } from "app/shared/service/media.service";
import { Criteria } from "app/shared/utils/criteria.model";
import { SearchCriteria } from "app/shared/utils/searchCriteria";
import { SearchCriteriaGroup } from "app/shared/utils/searchCriteriaGroup";
import { Observable, Subject } from "rxjs";
import { filter, first, map, switchMap, take, takeUntil, takeWhile, tap } from "rxjs/operators";

@Component({
    selector: "footer",
    templateUrl: "./footer.component.html",
    styleUrls: ["./footer.component.scss"],
})
export class FooterComponent {
    documentation$: Observable<Documentation>;
    documentation: Documentation;
    sousdocumentation$: Observable<SousDocumentation>;
    sousdocumentation: SousDocumentation;
    destroyed$ = new Subject<boolean>();
    visible: boolean = false;
    isExist: boolean = false;
    subDoc: boolean = false;
    isVisible: boolean = false; // Modal visibility is initially false

    sousdocumentations$: Observable<SousDocumentation[]>;
    listsousdocumentations: SousDocumentation[] = [];
    listsousdocumentations2: SousDocumentation[] = [];
    @ViewChild("menuTrigger") menuTrigger!: MatMenuTrigger;
    videoPath: any;
    isSousDocsAvailable: boolean = false;
    /**
     * Constructor
     */
    constructor(
        private _route: ActivatedRoute,
        private _spinnerService: SpinnerService,
        private _router: Router,
        private actions$: Actions,
        private _mediaService: MediaService,
        private _sanitizer: DomSanitizer,
        private _documentationFacde: DocumentationFacade,
        private _sousdocumentationFacade: SousDocumentationFacade,
        private _store: Store<AuthState>
    ) { }
    // ngOnInit(): void {
    //     this._route.data.subscribe((data) => console.log({ ...data }));
    //     this._router.events
    //         .pipe(filter((event) => event instanceof NavigationEnd))
    //         .subscribe((event: NavigationEnd) => {
    //             if (event.url) {
    //                 this.isExist = false;
    //                 this.checkIfHelpExist(event.url);
    //             }
    //         });
    // }

    ngOnInit(): void {
        this._route.data.subscribe((data) => console.log({ ...data }));

        // Check if the user is logged in before proceeding with the logic
        this._store.select(getAuthState)
            .pipe(
                filter(data => data.loggedIn === true), // Only proceed if the user is logged in
                take(1), // Take only one emission
                switchMap(() => this._router.events.pipe(
                    filter((event) => event instanceof NavigationEnd),
                    tap((event: NavigationEnd) => {
                        if (event.url) {
                            this.isExist = false;
                            this.checkIfHelpExist(event.url);
                        }
                    })
                ))
            )
            .subscribe();
    }

    checkIfHelpExist(currentPath) {
        const slashCount = currentPath.split("/").length - 1;

        if (slashCount >= 2) {
            const extractedString = currentPath.split("/")[1];
            this.documentation = new Documentation();
            this.documentation$ =
                this._documentationFacde.getDocumentationByName(
                    extractedString
                );
            this.documentation$.subscribe((documentation) => {
                this.isExist = !!documentation;
                this.documentation = documentation;
            });
        } else if (slashCount == 1) {
            const extractedString = currentPath.split("/")[1];
            const listString = "list-";
            const nameList = listString.concat(extractedString);

            this.sousdocumentation = new SousDocumentation();
            this.sousdocumentation$ =
                this._sousdocumentationFacade.getSousDocumentationByName(
                    nameList
                );
            this.sousdocumentation$.subscribe((sousdocumentation) => {
                this.isExist = !!sousdocumentation;
                this.sousdocumentation = sousdocumentation;
            });
        }
    }
    onHelpClick() {
        const currentPath = this._router.url;
        const slashCount = currentPath.split("/").length - 1;
        if (
            this.sousdocumentation &&
            this.sousdocumentation.name &&
            this.sousdocumentation.name.includes("list-") &&
            slashCount == 1
        ) {
            // Close the menu first
            if (this.menuTrigger) {
                this.menuTrigger.closeMenu();
            }
            this.videoPath = null;

            this._spinnerService.show();
            this._mediaService
                .getBlob(this.sousdocumentation.fichier)
                .pipe(
                    map((blob) => {
                        const mimeType = blob.type; // Get MIME type from the blob
                        const isVideo = mimeType.startsWith("video/"); // Check if it's a video
                        const urlFile = isVideo
                            ? this._sanitizer.bypassSecurityTrustResourceUrl(
                                URL.createObjectURL(blob)
                            )
                            : null;

                        return { urlFile, isVideo };
                    })
                )
                .subscribe(({ urlFile, isVideo }) => {
                    if (isVideo) {
                        this.videoPath = urlFile; // Set videoPath only if it's a video
                        this._spinnerService.hide();
                        this.isVisible = true;
                    } else {
                        console.log("Your file is not a video.");
                        this._spinnerService.hide();
                        this._mediaService.openFile(
                            this.sousdocumentation.fichier
                        );
                    }
                });
        } else {
            this.getSubDocByDocumentation(this.documentation);
        }
    }

    openParentDocumentation() {
        // Close the menu first
        if (this.menuTrigger) {
            this.menuTrigger.closeMenu();
        }
        if (this.documentation.fichier) {
            this.videoPath = null; // Reset videoPath temporarily
            this._spinnerService.show();
            this._mediaService
                .getBlob(this.documentation.fichier)
                .pipe(
                    map((blob) => {
                        const mimeType = blob.type; // Get MIME type from the blob
                        const isVideo = mimeType.startsWith("video/"); // Check if it's a video
                        const urlFile = isVideo
                            ? this._sanitizer.bypassSecurityTrustResourceUrl(
                                URL.createObjectURL(blob)
                            )
                            : null;

                        return { urlFile, isVideo };
                    })
                )
                .subscribe(({ urlFile, isVideo }) => {
                    if (isVideo) {
                        this.videoPath = urlFile; // Set videoPath only if it's a video
                        this._spinnerService.hide();
                        this.isVisible = true;
                    } else {
                        console.log("Your file is not a video.");
                        this._spinnerService.hide();
                        this._mediaService.openFile(this.documentation.fichier);
                    }
                });
        }
    }

    onSousDocumentationClick(sousDoc: SousDocumentation): void {
        if (sousDoc.fichier || sousDoc.fileHelp) {
            this.videoPath = null;
            this._spinnerService.show();
            this._mediaService
                .getBlob(sousDoc.fichier)
                .pipe(
                    map((blob) => {
                        const mimeType = blob.type; // Get MIME type from the blob
                        const isVideo = mimeType.startsWith("video/"); // Check if it's a video
                        const urlFile = isVideo
                            ? this._sanitizer.bypassSecurityTrustResourceUrl(
                                URL.createObjectURL(blob)
                            )
                            : null;

                        return { urlFile, isVideo };
                    })
                )
                .subscribe(({ urlFile, isVideo }) => {
                    if (isVideo) {
                        this.videoPath = urlFile; // Set videoPath only if it's a video
                        this._spinnerService.hide();
                        this.isVisible = true;
                    } else {
                        console.log("Your file is not a video.");
                        this._spinnerService.hide();
                        this._mediaService.openFile(sousDoc.fichier);
                    }
                });
        } else {
        }
    }

    getSubDocByDocumentation(selectedDocumentation: Documentation): void {
        if (selectedDocumentation?.id) {
            //this._spinnerService.show();

            const criteria = new Criteria();
            const sousdocumentationCriterias = [
                new SearchCriteria(
                    "documentation.id",
                    "=",
                    selectedDocumentation.id,
                    true
                ),
            ];
            const sousdocumentationCriteriaGroup = new SearchCriteriaGroup(
                sousdocumentationCriterias
            );
            criteria.filter = [sousdocumentationCriteriaGroup];

            // Fetch the sousdocumentations using the facade
            // this.sousdocumentations$ = this._sousdocumentationFacade.all$;
            this.sousdocumentations$ = this._sousdocumentationFacade.all$.pipe(
                map((sousDocs) =>
                    sousDocs.filter(
                        (sousDoc) => !sousDoc.name.includes("list-")
                    )
                )
            );

            this._sousdocumentationFacade.loadAll(criteria);

            this.sousdocumentations$
                .pipe(
                    takeUntil(this.destroyed$),
                    tap((sousdocumentations) => {
                        if (this.listsousdocumentations.length > 0) {
                            this.subDoc = true;
                        }
                        this.listsousdocumentations = sousdocumentations;
                    })
                )
                .subscribe((sousdocumentations) => {
                    if (this.listsousdocumentations.length > 0) {
                        this.subDoc = true;
                    }
                    this.listsousdocumentations = sousdocumentations;
                });

            this.actions$
                .pipe(
                    ofEntityType(
                        SousDocumentation,
                        EntityActionTypes.LoadAllSuccess
                    ),
                    takeUntil(this.destroyed$),
                    map((action: any) => action.entities) // Extract the `entities` array from the action payload
                )
                .subscribe((entities) => {
                    if (entities.length == 1) {
                        if (entities[0].name.includes("list-")) {
                            this.menuTrigger.closeMenu();
                            this.openParentDocumentation();
                        }
                    }
                    if (entities.length == 0) {
                        this.menuTrigger.closeMenu();
                        this.openParentDocumentation();
                    }

                    this._spinnerService.hide();
                });

            this.actions$
                .pipe(
                    ofEntityType(
                        SousDocumentation,
                        EntityActionTypes.LoadAllFailure
                    ),
                    takeUntil(this.destroyed$)
                )
                .subscribe((succes) => {
                    this._spinnerService.hide();
                });
        } else {
            this.sousdocumentations$ = null;
        }
    }

    showDialog() {
        // this.visible = true;
    }
}
